import { cn } from '@/lib/utils';
import { EnvelopeSimpleIcon } from '@phosphor-icons/react';
import useGetInboundEmail from '@/api/core/inbound-emails/getInboundEmail';
import { T } from 'gt-react';

interface InboundEmailPreviewProps {
  entityId: string;
  className?: string;
}

export function InboundEmailPreview({
  entityId,
  className,
}: InboundEmailPreviewProps) {
  const {
    data: email,
    isLoading,
    isError,
  } = useGetInboundEmail({ inboundEmailId: entityId });

  if (isLoading) {
    return (
      <div className={cn('min-w-64 max-w-sm p-3', className)}>
        <div className="text-sm text-muted-foreground">
          <T context="loading inbound email">Loading...</T>
        </div>
      </div>
    );
  }

  if (isError) {
    return (
      <div className={cn('min-w-64 max-w-sm p-3', className)}>
        <div className="text-sm text-muted-foreground">
          <T context="error loading inbound email">
            Failed to load email details
          </T>
        </div>
      </div>
    );
  }

  if (!email) {
    return null;
  }

  return (
    <div className={cn('min-w-64 max-w-sm p-3', className)}>
      <div className="flex items-center gap-2 mb-2">
        <EnvelopeSimpleIcon className="size-4 text-muted-foreground" />
        <h4 className="text-sm font-semibold">
          <T context="inbound email preview title">Email Details</T>
        </h4>
      </div>
      <div className="text-sm space-y-1">
        <div>
          <span className="text-muted-foreground">
            <T context="email subject label">Subject: </T>
          </span>
          <span className="font-medium">
            {email.subject ? (
              email.subject
            ) : (
              <T context="no email subject placeholder">(No subject)</T>
            )}
          </span>
        </div>
        {email.textContent && (
          <div className="text-muted-foreground text-xs line-clamp-3 mt-2">
            {email.textContent}
          </div>
        )}
      </div>
    </div>
  );
}
